/**
 * A frozen empty array instance for selectors
 * (sometimes used in selectors for a default return value)
 */
export const IMMUTABLE_EMPTY_ARRAY = Object.freeze([] as unknown[]);

export const FIELDS = Object.freeze({
    QUERY_PARAMS: 'queryParams',
    SIZE: 'size',
    QUERY: 'query',
    PAGE: 'page',
    SORT: 'sort',
    LOADING: 'loading',
    META: 'meta',
    QUERY_FIELDS: 'queryFields',
} as const);

export const DEFAULT_PAGE_SIZE = 25;

export const BASE_QUERY_PARAMS = Object.freeze({
    [FIELDS.QUERY]: undefined,
    [FIELDS.SORT]: undefined,
    [FIELDS.PAGE]: 0,
    [FIELDS.SIZE]: DEFAULT_PAGE_SIZE,
});
